import { render, staticRenderFns } from "./IcoRewardStore.vue?vue&type=template&id=a0186acc"
import script from "./IcoRewardStore.vue?vue&type=script&lang=js"
export * from "./IcoRewardStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports